/**
 * NotFound — 404 fallback page.
 * Rendered when no route matches the current URL.
 */

import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Stack } from '@mui/material';
import Container from '@/components/PageSheet';
import HomeIcon from '@mui/icons-material/Home';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Stack spacing={3} alignItems="center" textAlign="center">
        <Typography variant="h2" fontWeight={800} color="text.secondary">
          404
        </Typography>
        <Typography variant="h6">
          {t('common.error')}
        </Typography>
        <Box>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            startIcon={<HomeIcon />}
          >
            {t('common.back')}
          </Button>
        </Box>
      </Stack>
    </Container>
  );
}

export default NotFound;
